import { render } from "./TestAnchuoorIos.vue?vue&type=template&id=f8316258"
import script from "./TestAnchuoorIos.vue?vue&type=script&lang=js"
export * from "./TestAnchuoorIos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__